/* eslint-disable react/no-array-index-key */
import cx from 'classnames';
import { forwardRef, memo } from 'react';

import CloseIcon from '../SVGIcons/CloseIcon';
import classes from './tech-divisions-card.module.scss';

interface IStackCardProps {
  title: string;
  firstSubtitle: string;
  firstText: string;
  fourthSubtitle: string;
  fourthText: string;
  secondSubtitle: string;
  secondText: string;
  thirdSubtitle: string;
  thirdText: string;
  rows?: number;
  handleClose: () => void;
}

const TechDivisionsCard = forwardRef<HTMLDivElement, IStackCardProps>(
  (
    {
      title,
      firstSubtitle,
      firstText,
      fourthSubtitle,
      fourthText,
      secondSubtitle,
      secondText,
      thirdSubtitle,
      thirdText,
      rows,
      handleClose,
    }: IStackCardProps,
    ref,
  ) => {
    const subtitles = [
      firstSubtitle,
      secondSubtitle,
      thirdSubtitle,
      fourthSubtitle,
    ];
    const texts = [firstText, secondText, thirdText, fourthText];

    return (
      <div className={classes.container} ref={ref}>
        <div className={classes.cardHeader}>
          <p className={classes.heading}>{title}</p>
          <div>
            <CloseIcon
              className={classes.close}
              fill="#1D1D1D"
              onClick={handleClose}
            />
          </div>
        </div>
        <div
          className={cx(classes.stack, {
            [classes.stackFour]: rows === 4,
            [classes.stackTwo]: rows === 2,
          })}
        >
          {texts.map(
            (text, index) => text && (
            <div key={index} className={classes.stackContainer}>
              {rows === 4 && (
              <p className={classes.cardHeader}>{subtitles[index]}</p>
              )}
              <p className={classes.cardText}>{text}</p>
            </div>
            ),
          )}
        </div>
      </div>
    );
  },
);

export default memo(TechDivisionsCard);
